import { render, staticRenderFns } from "./RadioButtons.vue?vue&type=template&id=dc102d02&"
import script from "./RadioButtons.vue?vue&type=script&lang=ts&"
export * from "./RadioButtons.vue?vue&type=script&lang=ts&"
import style0 from "./RadioButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports